export const TACTIC_FORM_MAX_SELECTED_CATEGORIES = 5;
export const TACTIC_FORM_MAX_SELECTED_SEGMENTS = 2;
